import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Register service worker for PWA.
// IMPORTANT: Never allow localhost/dev to get stuck on cached UI.
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '0.0.0.0');

if ('serviceWorker' in navigator) {
  // In DEV, always clean up SW + caches (even when accessed via LAN IP),
  // to avoid stale UI or stale env-config behavior.
  const shouldCleanup = import.meta.env.DEV || isLocalhost;

  // Always clean up SW + caches when shouldCleanup is true.
  if (shouldCleanup) {
    window.addEventListener('load', async () => {
      try {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      } catch {}
      try {
        const keys = await caches.keys();
        await Promise.all(keys.filter((k) => k.startsWith('cbn-')).map((k) => caches.delete(k)));
      } catch {}
    });
  } else if (import.meta.env.PROD) {
    // Production only (non-localhost)
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          // Ask the SW to check for updates on load.
          try { registration.update?.(); } catch {}
          console.log('Service Worker registered:', registration);
        })
        .catch((error) => {
          console.log('Service Worker registration failed:', error);
        });
    });
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
